import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators';

@customElement('vessel-loader')
export class VesselLoader extends LitElement {
  @property({ type: Boolean }) open: boolean = false;
  @property({ type: Number }) textIndex: number = 0;
  @property({ type: String }) headerText: string = '';
  @property({ type: Boolean }) showCancelButton: boolean = false;

  private loadingTexts: string[] = [
    "Navigating through the waves of data… Almost there!",
    "Anchoring your results… Just a moment!",
    "Sailing through the digital sea… ETA: A few seconds!",
    "Calibrating compasses… Aligning your results!",
    "Hold the helm steady… We're almost there!",
    "Setting sail for your results… Just a moment!",
    "Navigating through the digital currents… Almost there!",
  ];

  static styles = css`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 1000;
    }

    .loader-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
    }

    .loading-img {
      width: 200px;
      height: 200px;
    }

    .loading-text {
      font-size: 18px;
      font-family: MaerskText;
      animation: fadeInOut 8s infinite ease-in-out;
    }

    @keyframes fadeInOut {
      0%, 100% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
    }
  `;

  render() {
    return html`
      <mc-modal
        heading=${this.headerText}
        body="Please hold tight while we navigate through the waves of data. This might take a few moments, but we'll get you there safely!"
        zindex="99999"
        height="457px"
        hiddenclose
        backdropcloseactiondisabled
        escapecloseactiondisabled
        entercloseactiondisabled
        ?open=${this.open}
        >
        <div class="loader-content">
          <img src="./assets/images/ship-loader.gif" class="loading-img" />
          <p class="loading-text">${this.loadingTexts[this.textIndex]}</p>
        </div>
        ${ this.showCancelButton ? html`
            <mc-button
            slot="secondaryAction"
            appearance="neutral"
            variant="filled"
            dialogaction="cancel"
            fit="small"
            @click="${this._onCancelClick}"
            >
            Cancel
            </mc-button>`
        : nothing
        }
      </mc-modal>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this._startTextRotation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this._textRotationInterval);
  }

  private _textRotationInterval: number | undefined;

  private _startTextRotation() {
    this._textRotationInterval = window.setInterval(() => {
      this.textIndex = (this.textIndex + 1) % this.loadingTexts.length;
      this.requestUpdate();
    }, 8000);
  }

  private _onCancelClick() {
    this.dispatchEvent(new CustomEvent('cancel-loader', { bubbles: true, composed: true }));
  }
}
